<div
  class="relative h-full w-full outline-none"
  [class.ring-2]="isDraggingOver()"
  [class.ring-inset]="isDraggingOver()"
  [class.ring-brand-400]="isDraggingOver()"
  tabindex="0"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)">

  <vflow
    view="auto"
    [nodes]="vflowNodes()"
    [edges]="vflowEdges()"
    [background]="background"
    [snapGrid]="snapGrid"
    [connection]="connectionSettings"
    [keyboardShortcuts]="keyboardShortcuts"
    [minZoom]="0.2"
    [maxZoom]="3"
    [elevateNodesOnSelect]="true"
    (connect)="onConnect($event)"
    (nodeDragStart)="onNodeDragStart()"
    (nodeDragEnd)="onNodeDragEnd($event)"
    (nodesChanges.select)="onNodeSelectChange($event)"
    (edgesChanges.select)="onEdgeSelectChange($event)">
    <mini-map />
  </vflow>

  <!--
    Barra de acciones sobre la selección (INC_CRM_020 (6) inc17).

    Duplicar ya existía por Ctrl+D y en el inspector, pero el inspector solo muestra UN nodo y un
    atajo no se descubre solo: QA lo reportó como "no existe la opción de duplicar". Esta barra
    aparece en cuanto hay selección y es la única vía visible para duplicar un GRUPO.
  -->
  @if (!isReadOnly() && activeSelection().length > 0) {
    <div class="z-sticky absolute left-1/2 top-4 flex -translate-x-1/2 items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-1.5 shadow-sm dark:border-gray-700 dark:bg-gray-900">
      <span class="text-xs font-medium text-gray-600 dark:text-gray-300">
        {{ activeSelection().length }}
        {{ activeSelection().length === 1 ? 'nodo seleccionado' : 'nodos seleccionados' }}
      </span>
      <span class="h-4 w-px bg-gray-200 dark:bg-gray-700"></span>
      <button
        type="button"
        class="flex items-center gap-1.5 rounded px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-40 dark:text-gray-200 dark:hover:bg-white/10"
        [disabled]="duplicableCount() === 0"
        [title]="duplicableCount() === 0
          ? 'El disparador no se puede duplicar: un workflow solo admite uno'
          : 'Duplicar la selección con sus conexiones internas (Ctrl+D)'"
        (click)="duplicateSelection()">
        <i class="fa-solid fa-copy"></i>
        Duplicar
      </button>
    </div>
  }

  <!-- Controles de zoom. z-sticky: por encima del lienzo, por debajo de overlays globales.
       Abajo a la IZQUIERDA: el minimapa de vflow se dibuja en la esquina inferior derecha y los
       controles le caían encima, tapándolo a medias. -->
  <div class="z-sticky absolute bottom-4 left-4 flex items-center gap-1 rounded-lg border border-gray-200 bg-white p-1 shadow-sm dark:border-gray-700 dark:bg-gray-900">
    <button
      type="button"
      class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/10"
      title="Alejar"
      (click)="zoomOut()">
      <i class="fa-solid fa-minus text-xs"></i>
    </button>
    <span class="min-w-[3rem] text-center text-xs font-medium text-gray-600 dark:text-gray-300">{{ zoomLabel() }}</span>
    <button
      type="button"
      class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/10"
      title="Acercar"
      (click)="zoomIn()">
      <i class="fa-solid fa-plus text-xs"></i>
    </button>
    <span class="mx-0.5 h-4 w-px bg-gray-200 dark:bg-gray-700"></span>
    <button
      type="button"
      class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/10"
      title="Ajustar a la pantalla"
      (click)="fitView()">
      <i class="fa-solid fa-expand text-xs"></i>
    </button>
  </div>
</div>
